
const config = {
    baseUrl: "https://aca.media-aca.org",
    apiUrl: "https://admin.acaindia.org"
  };
  
  export default config;
  